/*
 * Copyright 2018 Red Hat, Inc. and/or its affiliates.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import * as React from "react";
export class MessageHelper extends React.Component {
    constructor(props) {
        super(props);
    }
    static localize(msgKey, params) {
        let message = l18nMsg[this.processKey(msgKey)];
        if (message === undefined) {
            message = msgKey;
        }
        if (params && params.length > 0) {
            params.forEach((value, index) => {
                if (value) {
                    value = this.processParam(value);
                    message = message.replace(`{{param_${index}}}`, value);
                }
            });
        }
        return this.decodeUnicodeEscapes(decodeURI(message));
    }
    static decodeUnicodeEscapes(input) {
        return input.replace(/\\u[\dA-F]{4}/gi, (match) => String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16)));
    }
    static localizeWithChildren(msgKey, children) {
        const message = l18nMsg[this.processKey(msgKey)];
        const parts = message.split(/\{\{param_\d*}}/);
        const count = React.Children.count(children);
        return React.Children.map(children, (child, i) => [parts[i], child, count === i + 1 ? parts[count] : ""]);
    }
    static processKey(msgKey) {
        if (!(msgKey.startsWith("${") && msgKey.endsWith("}"))) {
            return msgKey;
        }
        return msgKey.substring(2, msgKey.length - 1);
    }
    static processParam(param) {
        if (!(param.startsWith("${") && param.endsWith("}"))) {
            return param;
        }
        const key = param.substring(2, param.length - 1);
        const value = l18nMsg[key];
        if (value === undefined) {
            return param;
        }
        return value;
    }
    render() {
        if (this.props.children) {
            return MessageHelper.localizeWithChildren(this.props.msgKey, this.props.children);
        }
        return MessageHelper.localize(this.props.msgKey, this.props.params);
    }
}
